// context/FlowContext/FlowContext.js
import React, { createContext, useContext, useReducer } from 'react';
import { flowReducer, initialState, ActionTypes } from './flowReducer';

const FlowStateContext = createContext(undefined);
const FlowDispatchContext = createContext(undefined);

export const FlowProvider = ({ children }) => {
  const [state, dispatch] = useReducer(flowReducer, initialState);

  return (
    <FlowStateContext.Provider value={state}>
      <FlowDispatchContext.Provider value={dispatch}>
        {children}
      </FlowDispatchContext.Provider>
    </FlowStateContext.Provider>
  );
};

// Custom hooks for consuming context
export const useFlowState = () => {
  const context = useContext(FlowStateContext);
  if (context === undefined) {
    throw new Error('useFlowState must be used within a FlowProvider');
  }
  return context;
};

export const useFlowDispatch = () => {
  const context = useContext(FlowDispatchContext);
  if (context === undefined) {
    throw new Error('useFlowDispatch must be used within a FlowProvider');
  }
  return context;
};

// Convenience hook that provides actions
export const useFlow = () => {
  const state = useFlowState();
  const dispatch = useFlowDispatch();

  const addHistoryEvent = (event) => {
    console.log("addHistoryEvent", event);
    dispatch({ type: ActionTypes.ADD_HISTORY_EVENT, payload: event });
  };

  const undo = () => {
    if (state.undoPosition >= 0) {
      const event = state.undoHistory[state.undoPosition];
      dispatch({ type: ActionTypes.UNDO });
      return event;
    }
    return null;
  };

  const redo = () => {
    if (state.undoPosition < state.undoHistory.length - 1) {
      dispatch({ type: ActionTypes.REDO });
      return state.undoHistory[state.undoPosition + 1];
    }
    return null;
  };

  const setIsLocked = (isLocked) => {
    console.log("useReducer - isLocked: ", isLocked);
    dispatch({ type: ActionTypes.SET_LOCKED, payload: isLocked });
  };

  const setPanMode = (mode) => {
    dispatch({ type: ActionTypes.SET_PAN_MODE, payload: mode });
  };

  const updateUndoHistory = (undoHistory, undoPosition) => {
    dispatch({ type: ActionTypes.UPDATE_UNDO_HISTORY, payload: { undoHistory, undoPosition } });
  };

  const setShowAllModuleOverlays = (show) => {
    dispatch({ 
      type: ActionTypes.SET_SHOW_ALL_MODULE_OVERLAYS, 
      payload: show 
    });
  };  

  return {
    isLocked: state.isLocked,
    setIsLocked,
    panMode: state.panMode,
    setPanMode,
    addHistoryEvent,
    undo,
    redo,
    undoHistory: state.undoHistory,
    undoPosition: state.undoPosition,
    updateUndoHistory,
    showAllModuleOverlays: state.showAllModuleOverlays,
    setShowAllModuleOverlays  
  };
};